import React from "react";
import ReactDOM from "react-dom/client";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle";
import "./index.css";
import App from "./App";
import { UserProvider } from "./context/UserContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GoogleOAuthProvider } from "@react-oauth/google";

const key = process.env.REACT_APP_GOOGLE_API;
console.log("key7", key);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={key}>
      <UserProvider>
        <ToastContainer className={"z-[9999]"} />
        <App />
      </UserProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);
